import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from './components/nuxt-error.vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../node_modules/element-ui/lib/theme-chalk/index.css'

import '../node_modules/vue-waves-effect/dist/vueWavesEffect.css'

import '../theme/index.css'

import '../styles/index.scss'

import '../static/js/materialize/css/materialize.css'

import '../assets/font/iconfont.css'

import _2d21a7c7 from '../layouts/base.vue'
import _459ed052 from '../layouts/components/AppMain.vue'
import _7d8301ec from '../layouts/components/float-user-info/float-user-info.vue'
import _8fa50c08 from '../layouts/components/guide/index.vue'
import _090dffda from '../layouts/components/Navbar.vue'
import _11d73c86 from '../layouts/components/Sidebar/FixiOSBug.js'
import _6e0726fc from '../layouts/components/Sidebar/index.vue'
import _9e2cf86e from '../layouts/components/Sidebar/Item.vue'
import _9e2a8ea0 from '../layouts/components/Sidebar/Link.vue'
import _9e2a633e from '../layouts/components/Sidebar/Logo.vue'
import _5b44cb19 from '../layouts/components/Sidebar/SidebarItem.vue'
import _6f6c098b from '../layouts/default.vue'
import _27ea919c from '../layouts/errorLayout.vue'

const layouts = { "_base": sanitizeComponent(_2d21a7c7),"_components/AppMain": sanitizeComponent(_459ed052),"_components/float-user-info/float-user-info": sanitizeComponent(_7d8301ec),"_components/guide/index": sanitizeComponent(_8fa50c08),"_components/Navbar": sanitizeComponent(_090dffda),"_components/Sidebar/FixiOSBug": sanitizeComponent(_11d73c86),"_components/Sidebar/index": sanitizeComponent(_6e0726fc),"_components/Sidebar/Item": sanitizeComponent(_9e2cf86e),"_components/Sidebar/Link": sanitizeComponent(_9e2a8ea0),"_components/Sidebar/Logo": sanitizeComponent(_9e2a633e),"_components/Sidebar/SidebarItem": sanitizeComponent(_5b44cb19),"_default": sanitizeComponent(_6f6c098b),"_errorLayout": sanitizeComponent(_27ea919c) }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map((page) => {
        const p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$fetch) {
          p.push(page.$fetch())
        } else {
          // Get all component instance to call $fetch
          for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
            p.push(component.$fetch())
          }
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    },
  },

  components: {
    NuxtLoading
  }
}
